<template>
	<div>
		<cIndex></cIndex>
		<div class="successfulpayment">
			<h3>支付成功</h3>
			<div>
				<img src="../assets/duihao.png" alt="">
				<p class="p1">支付成功！</p>
				<p class="p2"><span>2s后跳转到 </span>
					<router-link to="/startTest">脑检测页面</router-link>
				</p>
			</div>
		</div>
	</div>
</template>
<script>
	import cIndex from '@/components/header'
	const components = {
		cIndex
	}
	export default {
		components: components,
		created() {
				 setTimeout(() => {
				 	this.$http.post(urls.urltest + "/personal/checkUser.json",{
						token:localStorage.getItem('token'),
						phone:localStorage.getItem('phone')
					}).then(function(res){
						if(res.body == '0'){
							 this.$router.push('/startTest')
							}else{
							this.$router.push('/gamelist')
						}
					})
				}, 3000)
		},
	}
</script>

<style lang="scss">
	@import "../styles/core/reset.scss";
	.successfulpayment {
		width: 8rem;
		height: 5rem;
		background: #fff;
		box-shadow: 0 0 3px #C3C3C3;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		@include flexbox;
		@include flex-direction(column);
		h3 {
			height: .6rem;
			line-height: .6rem;
			text-align: center;
			font-size: 16px;
			color: #555555;
			border-bottom: 1px solid #eee;
			position: relative;
		}
		div {
			@include flex;
			width: 100%;
			position: relative;
			img {
				position: absolute;
				left: 50%;
				top: .6rem;
				transform: translate(-50%, 0);
			}
			.p1 {
				position: absolute;
				top: 1.8rem;
				left: 50%;
				transform: translate(-50%, 0);
				font-size: 16px;
				color: #555555;
			}
			.p2 {
				position: absolute;
				top: 2.2rem;
				left: 50%;
				transform: translate(-50%, 0);
				font-size: 16px;
				color: #555555;
				font-size: .14rem;
				span {
					color: #999;
				}
				a {
					border-bottom: 1px solid #00afc7;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// cardSucc.vue?27844b0c